// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__7jHDJ","col":"styles_col__1cyZP"};